import EditSmartTip from './EditSmartTip';

export default EditSmartTip;
